<div class="ui-empty-page flex flex-column align-center gap-4">
  <div class="image">
    <img src="/assets/icons/svgs/empty.svg" alt="" />
  </div>
  <h4 class="title">{{ title }}</h4>
  <div class="sub-title">
    {{ message }}
  </div>
</div>
